/* Project Import will be here */
import { post, IRequest } from "../index";
import { IStaticContentParams } from "models/commonModels";
/* Project Import will be here */

export const getStaticContentListApi = (data: IStaticContentParams) => {
  const request: IRequest = {
    subUrl: `/AppConfig/StaticContent`,
    data
  };

  return post(request);
}